import { Sanity$TrustVendor } from '@otovo/shared/types/sanityTypes';

import { stegaClean } from 'next-sanity';
import { GoogleStars } from '../../GoogleRating/GoogleStars';
import GoogleLogo from '../../GoogleRating/googleLogo.svg';
import TrustPilotStars from '../../TrustPilot/TrustPilotStars';
import WhiteLogo from '../../TrustPilot/trustpilot-logo-white.svg';

const vendors = Object.freeze({
  TRUSTPILOT: 'trustpilot',
  GOOGLE: 'google',
});

const vendorConfig = {
  [vendors.TRUSTPILOT]: {
    StarsComponent: TrustPilotStars,
    LogoComponent: WhiteLogo,
  },
  [vendors.GOOGLE]: {
    StarsComponent: GoogleStars,
    LogoComponent: GoogleLogo,
  },
};

const TrustVendor = ({ vendor, score, url, shortText }: Sanity$TrustVendor) => {
  const cleanedVendor = stegaClean(vendor);
  const config = vendorConfig[cleanedVendor as keyof typeof vendorConfig];

  if (!config) return null;

  const { StarsComponent, LogoComponent } = config;

  return (
    <div>
      <a
        href={url}
        className="inline-flex items-center gap-3 text-white"
        target="_blank"
        rel="noopener noreferrer"
      >
        <StarsComponent rating={score} />
        <span className="sr-only">{shortText || vendor}</span>
        <span className="text-2xl">
          <LogoComponent />
        </span>
      </a>
    </div>
  );
};

export default TrustVendor;
